import TradeContractBaseView, {
    ErrorArray,
    UninitializedStoreError
} from "@/components/pages/contract/TradeContract/TradeContractBaseView";
import {TradeContractFormat} from "@/store/modules/hcs/tradeContractFormat/model";
import {Store} from "vuex";
import {RootStateType} from "@/store";
import {ContractProfile} from "@/store/modules/hcs/contractProfile/model";
import ErrorMessage from "@/components/molecules/ErrorMessage";

type FormatError =
  'serviceProfile.noServiceProfile' |
  'serviceProfile.noProcessProfile' |
  'serviceProfile.noEventProfile' |
  'companionServiceProfile.noServiceComponentModel' |
  'companionServiceProfile.noProcessComponentModel' |
  'contractProfile.noProfiles';

export default class TradeContractFormatView extends TradeContractBaseView<TradeContractFormat> {
  constructor(tradeContract: TradeContractFormat, $store: Store<RootStateType>) {
    super(tradeContract, $store);
  }

  // /** 自分サービス構成モデルID */
  // get selfServiceComponentModelId() {
  //   if(this.isSelfConsume) {
  //     return this.tradeContractSource.consumerServiceComponentModelId;
  //   } else if(this.isSelfProduce) {
  //     return this.tradeContractSource.producerServiceComponentModelId;
  //   } else {
  //     return null;
  //   }
  // }
  // set selfServiceComponentModelId(selfServiceComponentModelId) {
  //   if(this.isSelfConsume) {
  //     this.updateTradeContractSource({consumerServiceComponentModelId: selfServiceComponentModelId});
  //   } else if(this.isSelfProduce) {
  //     this.updateTradeContractSource({producerServiceComponentModelId: selfServiceComponentModelId});
  //   }
  // }

  /** 相手サービス構成モデルID */
  get otherServiceComponentModelId() {
    if(this.isSelfConsume) {
      return this.tradeContractSource.producerServiceComponentModelId;
    } else if(this.isSelfProduce) {
      return this.tradeContractSource.consumerServiceComponentModelId;
    } else {
      return null;
    }
  }
  set otherServiceComponentModelId(otherServiceComponentModelId) {
    if(this.isSelfConsume) {
      this.updateTradeContractSource({producerServiceComponentModelId: otherServiceComponentModelId});
    } else if(this.isSelfProduce) {
      this.updateTradeContractSource({consumerServiceComponentModelId: otherServiceComponentModelId});
    }
  }

  // /** 自分プロセス構成モデルID */
  // get selfProcessComponentModelId() {
  //   if(this.isSelfConsume) {
  //     return this.tradeContractSource.consumerProcessComponentModelId;
  //   } else if(this.isSelfProduce) {
  //     return this.tradeContractSource.producerProcessComponentModelId;
  //   } else {
  //     return null;
  //   }
  // }
  // set selfProcessComponentModelId(selfProcessComponentModelId) {
  //   if(this.isSelfConsume) {
  //     this.updateTradeContractSource({consumerProcessComponentModelId: selfProcessComponentModelId});
  //   } else if(this.isSelfProduce) {
  //     this.updateTradeContractSource({producerProcessComponentModelId: selfProcessComponentModelId});
  //   }
  // }

  /** 相手プロセス構成モデルID */
  get otherProcessComponentModelId() {
    if(this.isSelfConsume) {
      return this.tradeContractSource.producerProcessComponentModelId;
    } else if(this.isSelfProduce) {
      return this.tradeContractSource.consumerProcessComponentModelId;
    } else {
      return null;
    }
  }
  set otherProcessComponentModelId(otherProcessComponentModelId) {
    if(this.isSelfConsume) {
      this.updateTradeContractSource({producerProcessComponentModelId: otherProcessComponentModelId});
    } else if(this.isSelfProduce) {
      this.updateTradeContractSource({consumerProcessComponentModelId: otherProcessComponentModelId});
    }
  }

  /**
   * すべての ContractProfile をロードします
   */
  async loadContractProfiles(): Promise<void> {
    const {data} = await this.hcsClient.get<ContractProfile[]>(`/contract_profiles`, {
      params: {
        tradeContractFormatIdEq: this.id
      }
    });
    this.contractProfiles = data;
  }

  /**
   * 契約プロファイルの数
   */
  get contractProfilesCount(): number {
    return Math.max(this.tradeContract.contractProfilesCount ?? 0, this.contractProfiles.length);
  }

  /**
   * エラーを ErrorMessage として取得します
   */
  errorMessages(): ErrorMessage[] {
    const toMessage = (e: FormatError) => {
      switch(e) {
        case 'serviceProfile.noServiceProfile':
          return 'サービスプロファイルが選択されていません。';
        case 'serviceProfile.noProcessProfile':
          return 'プロセスプロファイルが選択されていません。';
        case 'serviceProfile.noEventProfile':
          return 'イベントプロファイルが選択されていません。';
        case 'companionServiceProfile.noServiceComponentModel':
          return '受領側サービス構成モデルが選択されていません。';
        case 'companionServiceProfile.noProcessComponentModel':
          return '受領側プロセス構成モデルが選択されていません。';
        case 'contractProfile.noProfiles':
          return '契約プロファイルが必要です。';
      }
    };
    return this.errors().map(e => ({
      level: "warn",
      message: toMessage(e),
    }));
  }

  /**
   * エラーを取得します
   */
  errors(): ErrorArray<FormatError> {
    const result = new ErrorArray<FormatError>();
    if(!this.selfServiceProfileId) {
      result.push('serviceProfile.noServiceProfile');
    }
    if(!this.selfProcessProfileId) {
      result.push('serviceProfile.noProcessProfile');
    }
    if(!(this.isSelfProduce || this.selfEventProfileIds.length > 0)) {
      result.push('serviceProfile.noEventProfile');
    }
    // if(!this.otherServiceComponentModelId) {
    //   result.push('companionServiceProfile.noServiceComponentModel');
    // }
    // if(!this.otherProcessComponentModelId) {
    //   result.push('companionServiceProfile.noProcessComponentModel');
    // }
    if(this.contractProfilesCount === 0) {
      result.push('contractProfile.noProfiles');
    }
    return result;
  }

  /**
   * HCM 送信用データのベースとなるオブジェクトを生成します
   *
   * @private
   */
  private buildData() {
    const issuerRole = (() => {
      if(this.isSelfConsume) {
        return this.amiProposer ? 'consumer' : 'producer';
      } else if(this.isSelfProduce) {
        return this.amiProposer ? 'producer' : 'consumer';
      }
      throw new Error(`不正な serviceType: ${this.serviceType}`);
    })();
    const issuerMapperRole = (() => {
      switch(this.contractType) {
        case 'recruitment':
        case 'draft':
          return 'proposer';
        case "offer":
          return 'responder';
        default:
          throw new Error(`不正な contractType: ${this.contractType}`);
      }
    })();

    return {
      issuerRole, // producer or consumer
      issuerMapperRole, // proposer or responder
      sendType: this.sendType,
      producerDataProfileId: this.tradeContractSource.producerDataProfileId,
      consumerDataProfileId: this.tradeContractSource.consumerDataProfileId,
      producerServiceProfileId: this.tradeContractSource.producerServiceProfileId,
      consumerServiceProfileId: this.tradeContractSource.consumerServiceProfileId,
      producerProcessProfileId: this.tradeContractSource.producerProcessProfileId,
      consumerProcessProfileId: this.tradeContractSource.consumerProcessProfileId,
      producerEventProfileIds: this.tradeContractSource.producerEventProfileIds,
      consumerEventProfileIds: this.tradeContractSource.consumerEventProfileIds,

      consumerProcessComponentModelId: this.tradeContractSource.consumerProcessComponentModelId,
      producerProcessComponentModelId: this.tradeContractSource.producerProcessComponentModelId,
      consumerServiceComponentModelId: this.tradeContractSource.consumerServiceComponentModelId,
      producerServiceComponentModelId: this.tradeContractSource.producerServiceComponentModelId,

      unchangeable: this.tradeContractSource.unchangeable,
      contractProfileTemplateId: this.contractProfileTemplateId, // 契約内容を示すプロファイルのテンプレートID
    };
  }

  /**
   * 取引契約作成用データを生成します
   */
  buildPostData() {
    const buildData = this.buildData();
    return {
      ...buildData,
      name: this.name, // 契約の名称
      description: this.description, // 契約内容の簡単な説明
      commonDictionaryId: this.commonDictionaryId, // 共通辞書ID
      contractType: this.contractType,
      recipientTerminalId: this.tradeContractSource.recipientTerminalId,
    };
  }

  /**
   * 取引契約更新用データを生成します
   */
  buildPatchData() {
    const buildData = this.buildData();
    return {
      ...buildData,
      name: this.tradeContractSource.name,
      description: this.tradeContractSource.description,
      dataPropertyProfileMaps: this.tradeContractSource.dataPropertyProfileMaps,
    };
  }

  async fetchContractProfiles(): Promise<ContractProfile[]> {
    try {
      const {data} = await this.hcsClient.get('/contract_profiles', {
        params: {
          tradeContractFormatIdEq: this.tradeContract.id
        }
      });
      return data;
    } catch(e) {
      if(e instanceof UninitializedStoreError) {
        return [];
      }
      throw e;
    }
  }
}

/**
 * TradeContractFormatView を生成します
 *
 * @param tradeContract TradeContract
 * @param store Vuex ストア
 */
export function createTradeContractFormatView(tradeContract: TradeContractFormat, store: Store<RootStateType>) {
  return new TradeContractFormatView(tradeContract, store);
}

/**
 * 空の TradeContractFormatView を生成します
 */
export function emptyTradeContractFormatView() {
  // @ts-ignore
  return new TradeContractFormatView({}, {});
}
